import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SettingsActivitiesProgComponent } from './settings-activities-prog.component';
import { MaterialModule } from 'src/app/material.module';
import { ModulModule } from 'src/app/platform/nomenclatoare/activities-prog-setari/modul/modul.module';
import { LocatiiModule } from 'src/app/platform/nomenclatoare/activities-prog-setari/locatii/locatii.module';
import { SpecializariModule } from 'src/app/platform/nomenclatoare/activities-prog-setari/specializari/specializari.module';
import { OperatoriModule } from 'src/app/platform/nomenclatoare/activities-prog-setari/operatori/operatori.module';
import { ZileLibereModule } from 'src/app/platform/nomenclatoare/activities-prog-setari/zile-libere/zile-libere.module';
import { TipuriProblemeModule } from 'src/app/platform/nomenclatoare/activities-prog-setari/tipuri-probleme/tipuri-probleme.module';
import { ProgramModule } from 'src/app/platform/nomenclatoare/activities-prog-setari/program/program.module';
import { StatusModule } from 'src/app/platform/nomenclatoare/activities-prog-setari/status/status.module';
import { PrioritatiModule } from 'src/app/platform/nomenclatoare/activities-prog-setari/prioritati/prioritati.module';

@NgModule({
    declarations: [
        SettingsActivitiesProgComponent
    ],
    imports: [
        CommonModule,
        MaterialModule,
        ModulModule,
        LocatiiModule,
        SpecializariModule,
        OperatoriModule,
        ZileLibereModule,
        TipuriProblemeModule,
        ProgramModule,
        StatusModule,
        PrioritatiModule,
    ],
    exports: [SettingsActivitiesProgComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SettingsActivitiesProgModule { }
